module.exports = __webpack_public_path__ + "img/thumbnail_AmericanAlligator_f_albino.3c2d63a2.png";